// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__b-M1x","buttons":"RemoveExpirationActionButtons_buttons__CGRf4"};